import React from 'react';

import { Modal, ModalContent, ModalHeader, ModalTitle } from '@epoch-ui/components/Modal/modal';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';
import { EventEmailPreview } from '@epoch-components/EmailPreview';

interface EmailPreviewReminderModalProps extends React.ComponentPropsWithoutRef<typeof Modal> {
  message: string;
  title: string;
}

/**
 * Display a preview of an email message.
 * Note: Currently intended only for email reminders.
 * - Looking to support other previews or update name of this component to be reminder-specific
 */
export const EmailPreviewReminderModal: React.FC<EmailPreviewReminderModalProps> = ({
  message,
  title: emailTitle,
  ...modalProps
}) => {
  const event = useEditableEvent();

  return (
    <Modal {...modalProps}>
      <ModalContent className="tw-max-w-[688px]">
        <ModalHeader className="tw-mb-1">
          <ModalTitle>Reminder Preview</ModalTitle>
        </ModalHeader>
        <p className="tw-mb-4 tw-text-sm tw-leading-relaxed tw-text-primary-grey">
          Email Subject line: {emailTitle}
        </p>
        <EventEmailPreview event={event} message={message} />
      </ModalContent>
    </Modal>
  );
};
